/*
  «Почему система решила так» в шапке карточки счёта (21.10.2026, указание владельца).

  Раньше блок стоял под карточкой с деньгами. Владелец показал снимок шапки: справа под
  кнопками «Позвонить», «Отправить СМС», «Изменить данные», «К реестру», «Удалить счёт»
  пустое место, - и сказал поставить блок туда. Объяснение остаётся кнопкой, а не
  развёрнутым текстом: §4.5.2 требует доступности «из чего сложилось», а не того, чтобы оно
  всегда было развёрнуто.

  Живёт вне `CustomerWork`: тот перестраивает разметку, когда приходят дела, и раскрытый
  блок сворачивался сам (поймано тестом вкладок 06.10.2026).
*/

import { money } from '../api/format.js'
import Disclosure from './Disclosure.jsx'

export default function AccountWhy({ triage }) {
  return (
    <Disclosure title="Почему Арбитр ЖКХ решил так">
      <ul className="reasons">
        {triage.reasons.map((reason) => (
          <li key={reason}>{reason}</li>
        ))}
      </ul>
      <div className="muted">
        Ожидаемый возврат {money(triage.verdict.expected_recovery)} минус расходы{' '}
        {money(triage.verdict.action_cost)} = {money(triage.verdict.expected_return)}.
      </div>
    </Disclosure>
  )
}
